<template>
  <div class="container-fluid p-0 push-wrapper">
    <div class="container">
      <div class="row">
        <div class="col">
          <div class="row">
            <div class="col-12 my-header font-weight-bold">
              Редактирование ссылок
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="mt-5"></div>
    <div class="container">
      <div class="row align-items-center">
        <div class="col-sm-8">
          <button
            class="styled openLinkMaker"
            @click="$modal.show('link_modal')"
          >
            Создать ссылку
          </button>
        </div>
      </div>
    </div>
    <div class="container" v-if="links.length == 0 &amp;&amp; !loading">
      <div class="row align-items-center">
        <div class="col-sm-8 no_links">
          <i class="fas fa-arrow-up"></i>У вас ещё нет ссылок. Создайте первую!
        </div>
      </div>
    </div>
    <div class="container" v-if="loading">
      <div class="row link align-items-center">
        <div class="col">
          <div class="loader_holder">
            <object
              type="image/svg+xml"
              data="/assets/loaders/infinity.svg"
            ></object>
          </div>
        </div>
      </div>
    </div>
    <div class="container" v-if="!loading" v-for="link of links">
      <div class="row white_block link align-items-center">
        <div class="col-sm-6 preview">
          <div class="name">{{ link.name ? link.name : "Без имени" }}</div>
          <a :href="`https://sl.actid.ru/r/${link.short}`" target="blank"
            >sl.actid.ru/r/{{ link.short }}</a
          ><i class="fas fa-arrow-right"></i
          ><a :href="link.link" target="blank">{{ link.link }}</a>
        </div>
        <div class="col-sm-2 text-right">
          <div style="display: inline-block">
            <input-module
              type="checkbox"
              label="Включить"
              v-model="link.enabled"
              simple="1"
              @change="enabledToggle(link)"
            >
            </input-module>
          </div>
        </div>
        <div class="col-sm-4 text-right">
          <button class="styled" @click="showStats(link)">
            {{ link.show_stats ? "Скрыть" : "Открыть" }} статистику
          </button>
          <button
            class="styled"
            title="Создать QR-код по ссылке"
            style="margin-left: 5px"
            @click="createQR(link)"
            :disabled="!qr_connected"
          >
            <i class="fas fa-qrcode" style="margin: 0"></i>
          </button>
          <button class="styled removeLink" @click="removeLink(link)">
            <i class="far fa-trash-alt"></i>
          </button>
        </div>
      </div>
      <div class="row white_block stats" v-if="link.show_stats">
        <div class="col-sm">
          <div class="loader_holder" v-if="link.stats_loading">
            <object
              type="image/svg+xml"
              data="/assets/loaders/infinity.svg"
            ></object>
          </div>
          <div class="info" v-if="!link.stats_loading">
            <line-chart
              class="wide_chart"
              :chart-data="link.visit_chart"
            ></line-chart>
            <div class="container-fluid">
              <div class="row align-items-center">
                <div class="col-sm">
                  <div class="value">{{ link.stats.length }}</div>
                  <div class="label">Всего посещений</div>
                </div>
                <div class="col-sm">
                  <pie-chart
                    class="mini_pie_chart"
                    :chart-data="link.browser_chart"
                  ></pie-chart>
                </div>
                <div class="col-sm">
                  <pie-chart
                    class="mini_pie_chart"
                    :chart-data="link.os_chart"
                  ></pie-chart>
                </div>
                <div class="col-sm">
                  <pie-chart
                    class="mini_pie_chart"
                    :chart-data="link.browser_os_chart"
                  ></pie-chart>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <modal class="link_modal" name="link_modal" height="auto" :adaptive="true">
      <div class="close" @click="$modal.hide('link_modal')">
        <i class="fal fa-times"></i>
      </div>
      <div class="container">
        <div class="row">
          <div class="col">
            <h2>Создание короткой ссылки</h2>
            <div class="content">
              <div class="inputModule">
                <input-module
                  type="text"
                  title="Название ссылки"
                  v-model="name"
                >
                </input-module>
              </div>
              <div class="inputModule">
                <input-module
                  type="link"
                  title="Оригинальная ссылка"
                  v-model="link"
                >
                </input-module>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col buttons">
            <button
              class="styled createLink"
              :disabled="
                link == '' ||
                !link.includes('http') ||
                link.includes(' ') ||
                create_loading
              "
              @click="makeLink"
            >
              Создать ссылку
            </button>
          </div>
        </div>
      </div>
    </modal>
  </div>
</template>
<script>
import moment from "moment";
import apiDriver from "../../apiDriver";
import swal from "sweetalert2";
import "sweetalert2/dist/sweetalert2.css";
var MobileDetect = require("mobile-detect");
import LineChart from "./line_chart";
import PieChart from "./pie_chart";

export default {
  components: {
    LineChart,
    PieChart,
  },

  data() {
    return {
      links: [],
      link: "",
      name: "",
      create_loading: false,
      loading: true,
      qr_connected: false,
    };
  },

  computed: {},

  mounted() {
    this.getLinks();
    if (this.$route.query.create) this.$modal.show("link_modal");
    let subscriptions = this.$store.state.userData.subscriptions;
    let qr = subscriptions.find((x) => x.service_id == 7);
    if (qr) this.qr_connected = true;
  },

  methods: {
    createQR(link) {
      this.$router.push({
        path: "/qr?link=https://sl.actid.ru/r/" + link.short,
      });
    },
    async getLinks() {
      let links = (
        await apiDriver.services.api.get("sl", "links")
      ).data.links.filter((x) => !x.temp);
      for (let l of links) {
        l.show_stats = false;
        l.stats = [];
        l.stats_loading = true;
        l.stats_loaded = false;
      }
      links = links.sort((a, b) => b.id - a.id);
      this.links = links;
      this.loading = false;
    },
    async showStats(link) {
      link.show_stats = !link.show_stats;
      if (!link.stats_loaded) {
        let stats = (
          await apiDriver.services.api.get("sl", "link_statistic", link)
        ).data;
        link.stats = stats.statistic;
        link.stats_loaded = true;
        link.stats_loading = false;
        link.visit_chart = {
          labels: [],
          datasets: [
            {
              data: [],
              label: "Посещений",
              backgroundColor: "rgba(0,0,0,0)",
              borderColor: "#3f51b5",
            },
          ],
        };
        link.os_chart = {
          labels: [],
          datasets: [
            {
              data: [],
              label: "ОС",
              backgroundColor: [
                "#4caf50",
                "#3f51b5",
                "#2196f3",
                "#00bcd4",
                "#f44336",
                "#e91e63",
                "#9c27b0",
                "#673ab7",
                "#009688",
                "#cddc39",
                "#ff9800",
              ],
            },
          ],
        };
        link.browser_chart = {
          labels: [],
          datasets: [
            {
              data: [],
              label: "Браузер",
              backgroundColor: [
                "#4caf50",
                "#3f51b5",
                "#2196f3",
                "#00bcd4",
                "#f44336",
                "#e91e63",
                "#9c27b0",
                "#673ab7",
                "#009688",
                "#cddc39",
                "#ff9800",
              ],
            },
          ],
        };
        link.browser_os_chart = {
          labels: [],
          datasets: [
            {
              data: [],
              label: "ОС - Браузер",
              backgroundColor: [
                "#4caf50",
                "#3f51b5",
                "#2196f3",
                "#00bcd4",
                "#f44336",
                "#e91e63",
                "#9c27b0",
                "#673ab7",
                "#009688",
                "#cddc39",
                "#ff9800",
              ],
            },
          ],
        };
        let date_to_id = {};
        let os_to_id = {};
        let browser_to_id = {};
        let browser_os_to_id = {};
        let i = 0;
        for (let c = moment().add(-14, "days"); c < moment(); c.add(1, "day")) {
          link.visit_chart.labels.push(c.format("DD.MM.YYYY"));
          link.visit_chart.datasets[0].data.push(0);
          date_to_id[c.format("DD.MM.YYYY")] = i;
          i++;
        }
        i = 0;
        for (let s of stats.statistic) {
          let os = new MobileDetect(s.navigator).os() || "Неизвестно";
          if (link.os_chart.labels.includes(os)) continue;
          link.os_chart.labels.push(os);
          link.os_chart.datasets[0].data.push(0);
          os_to_id[os] = i;
          i++;
        }
        i = 0;
        for (let s of stats.statistic) {
          let browser =
            new MobileDetect(s.navigator).userAgent() || "Неизвестно";
          if (link.browser_chart.labels.includes(browser)) continue;
          link.browser_chart.labels.push(browser);
          link.browser_chart.datasets[0].data.push(0);
          browser_to_id[browser] = i;
          i++;
        }
        i = 0;
        for (let s of stats.statistic) {
          let nav = new MobileDetect(s.navigator);
          let user_agent = nav.userAgent() || "Неизвестно";
          let browser = nav.os() || "Неизвестно";
          if (browser == "Safari" && user_agent == "AndroidOS")
            browser = "Browser";
          let bos = browser + " - " + (user_agent || "Неизвестно");
          if (link.browser_os_chart.labels.includes(bos)) continue;
          link.browser_os_chart.labels.push(bos);
          link.browser_os_chart.datasets[0].data.push(0);
          browser_os_to_id[bos] = i;
          i++;
        }
        for (let s of stats.statistic) {
          if (date_to_id[moment(s.createdAt).format("DD.MM.YYYY")] != undefined)
            link.visit_chart.datasets[0].data[
              date_to_id[moment(s.createdAt).format("DD.MM.YYYY")]
            ]++;
          let nav = new MobileDetect(s.navigator);
          let os = nav.os() || "Неизвестно";
          let browser = nav.userAgent() || "Неизвестно";
          let bos = (os || "Неизвестно") + " - " + (browser || "Неизвестно");
          if (os_to_id[os] != undefined)
            link.os_chart.datasets[0].data[os_to_id[os]]++;
          if (browser_to_id[browser] != undefined)
            link.browser_chart.datasets[0].data[browser_to_id[browser]]++;
          if (browser_os_to_id[bos] != undefined)
            link.browser_os_chart.datasets[0].data[browser_os_to_id[bos]]++;
        }
      }
      this.$forceUpdate();
      // console.log(link.stats);
    },
    async removeLink(link) {
      swal({
        title: "Вы уверены?",
        text: "Она перестанет быть доступной, статистика будет удалена, а владельцы ссылки не смогут по ней перейти. Удаляем?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Да! Удаляй!",
        cancelButtonText: "Нет, стоп...",
      }).then((result) => {
        if (result) {
          apiDriver.services.api.post("sl", "remove", link);
          this.links = this.links.filter((x) => x.id != link.id);
          this.$toast.success("Ссылка удалена!");
        }
      });
    },
    async makeLink() {
      let disabled =
        this.link == "" ||
        !this.link.includes("http") ||
        this.link.includes(" ") ||
        this.create_loading;
      if (disabled) return true;
      this.create_loading = true;
      let url = this.link;
      let link_object = (
        await apiDriver.services.api.post("sl", "create", {
          link: url,
          name: this.name,
        })
      ).data;
      this.links.unshift(link_object);
      this.$forceUpdate();
      this.create_loading = false;
      this.$toast.success("Ссылка создана!");
      this.$modal.hide("link_modal");
    },
    async enabledToggle(link) {
      if (link.enabled == 1) {
        this.$toast.success("Ссылка включена");
      } else {
        this.$toast.success("Ссылка выключена");
      }
      await apiDriver.services.api.post("sl", "update", link);
    },
  },
};
</script>
<style scoped lang="stylus">
button.styled {
  &.removeLink {
    padding: 10px 6px;
    color: #F44336;
    border-color: #F44336;
    margin-left: 5px;

    &:hover {
      background: #F44336;
      color: white;
    }
  }
}

div {
  cursor: default;
}

.my-header {
  font-size: 26pt;
}

.header-pre-push {
  font-size: 1.5rem;
}

.header-push {
  font-size: 1.5rem;
  color: black;
}

.link {
  .preview {
    .name {
      font-weight: bold;
    }

    a {
      color: #9c9c9c;
      font-weight: 400;
      font-size: 10pt;
      margin-left: 0;

      &:hover {
        color: black;
      }
    }

    i {
      color: #9c9c9c;
      font-size: 8pt;
      margin: 0 10px;
    }
  }

  .removeLink i {
    margin: 0 10px;
  }
}

.stats {
  margin-top: -6px;

  .loader_holder {
    object {
      width: 100px;
    }
  }
}

.link_modal {
  .createLink {
    margin: 20px 0;
  }
}

.openLinkMaker {
  margin: 20px 10px;
  margin-top: 0;
}

.no_links {
  padding-left: 70px;
  color: gray;

  i {
    margin-right: 10px;
  }
}

.wide_chart {
  width: 100%;
  height: 200px;
}

.info {
  .value {
    font-size: 26pt;
    font-width: bold;
    text-align: center;
  }

  .label {
    text-align: center;
  }
}

.mini_pie_chart {
  width: 170px;
  margin: 0 auto;
  height: 170px;
  background: #f5f5f5;
  border-radius: 10px;
  padding: 10px;
  margin-top: 10px;
}

@media (prefers-color-scheme: dark) {
  button.styled.removeLink {
    background: #161616;
  }

  .link .preview a {
    &:hover {
      color: white;
    }
  }
}
</style>
